import React from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";
import PageTitle from "../components/PageTitle";
import { useTranslation } from "react-i18next";

const MyData = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const user = useSelector((state) => state.user.user);

  const formatKey = (key) => {
    const translatedKey = t(`myData.fields.${key}`);

    if (translatedKey !== `myData.fields.${key}`) {
      return translatedKey;
    }

    const spaced = key.replace(/_/g, " ");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  };

  const getValue = (value) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    }

    return value;
  };

  return (
    <>
      <Helmet>
        <title>{t("myData.metaTitle")}</title>
        <meta name="description" content={t("myData.metaDescription")} />
      </Helmet>

      <PageTitle>{t("myData.title")}</PageTitle>

      {user ? (
        <TableContainer
          component={Box}
          sx={{
            border: "1px solid " + theme.palette.divider,
            borderRadius: "4px",
            width: "max-content",
          }}
        >
          <Table>
            <TableBody>
              {Object.entries(user).map(([key, value]) => (
                <TableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontWeight: "bold" }}
                  >
                    {formatKey(key)}
                  </TableCell>
                  <TableCell>{getValue(value)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Alert severity="error">{t("myData.userNotFound")}</Alert>
      )}
    </>
  );
};

export default MyData;
